module.exports = __webpack_public_path__ + "img/Flag_of_the_Marshall_Islands.2307059e.svg";